export default {
  LandingPage: {
    // Polska / Polski
    intro_sub:
      'Daj drugie życie zużytemu opakowaniu i przyczyń się do ochrony środowiska.',
    title: 'Opakowanie Samsung Upcycle',
    sequence1_1: 'Dołącz do nas i zmniejszaj ilość odpadów.',
    sequence1_2:
      'dla zrównoważonego środowiska - przekształć opakowanie po telewizorze w przydatny przedmiot. Przewiń w dół i wykonaj swój pierwszy krok.',
    sequence2_1: 'Przedstawiamy Opakowanie Samsung Upcycle.',
    sequence2_2:
      'Pudełko telewizora jest zaprojektowane z myślą o recyklingu, dzięki czemu możesz przyczynić się do ochrony środowiska, tworząc z opakowania po telewizorze różne przedmioty domowego użytku.',
    sequence3_1: 'Podążaj za kropkami nadrukowanymi na opakowaniu',
    sequence3_2:
      'Wytnij i złóż opakowanie zgodnie z instrukcją, by stworzyć coś niesamowitego.',
    sequence4_1: 'Wybierz rzecz, którą chcesz stworzyć.',
    sequence4_2:
      'Przewiń w dół i wybierz model telewizora ze swojego opakowania. Następnie wybierz opcję projektu idealną dla Ciebie i rozpocznij swoją przygodę z przedmiotem, który chcesz stworzyć.',
    selectBox: 'Wybierz swój telewizor',
    moreActivity:
      "Więcej informacji na temat zrównoważonych działań podejmowanych przez Samsung.",
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'Crstal UHD', //update
    theFrame: 'The Frame', //update
    theSerif: 'The Serif', //update
    theSero: 'The Sero', //update
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitory', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Soundbar Q-Seria', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet01:'Soundbar w zestawie 1',
    SoundbarSet02:'Soundbar w zestawie 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/us/sustainability/overview/',
    // moreActivityLink:'https://www.samsung.com/pl/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/pl/sustainability/overview/',
    footer: `
    Copyright© 2019-2021 Samsung. Wszelkie prawa zastrzeżone.`,
  },
  ProductPage: {
    selectDesign: 'Wybierz wzór i twórz',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'Szafka RTV',
    StorageBox: 'Pudełko do przechowywania',
    MagazineRack: 'Stojak na gazety',
    CatHouse: 'Domek dla kota',
    CatTunnel: 'Tunel dla kota',
    BookShelf: 'Półka na książki',
    DeskShelf: 'Półka na biurko',
    BlackRhino: 'Zagrożone zwierzęta\n - Czarny nosorożec', //update
    PolarBear: 'Zagrożone zwierzęta\n - Niedźwiedź polarny', //update
    SeaTurtle: 'Zagrożone zwierzęta\n - Żółw morski', //update
    TheRider: 'Konik na biegunach', //update
    Kibe: 'Regał Kibe', //update
    Tessellate: 'Modułowy system\n przechowywania\n Tessellate', //update
    Twist: 'Kosz do\n przechowywania\n Twist', //update
    AlexCouchArmTable: 'Stolik kanapowy\n Alex', //update
    BlastOffClubHouse: 'Zabawkowy\n statek kosmiczny', //update
    KinokoTable: 'Stolik Kinoko', //update
    Magnuss: 'Multifunkcyjny\n stolik Magnuss', //update
    GIO: 'Multifunkcyjny\n  pojemnik Gio', //update
    PostCardPlanter: 'Stojak na\n  pocztówki', //update
    SneakerRack: 'Regał na buty', //update
    TheSoban: 'Miniaturowy\n stolik The Soban', //update
    ToolBox: 'Pudełko na\n narzędzia', //update
    DeskStationary: 'Przybornik',
    CoinBank: 'Skarbonka',
    MobileScanner:'Stojak na smartfon',
    TabletScanner:'Stojak na tablet',
    PetStairs:'Schody dla zwierząt',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'minuta',
    all:'ALL',
    in: 'cal',
    inOnly: 'cal',
    allBoxSize: 'Wszystkie rozmiary pudełek',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'instrukcje',
    prepare: 'Przygotuj pudełko.',
    LetsDesign: "Zacznijmy projektowanie.",
    drawParts: 'Narysuj części na pudełku.',
    note1: 'Pamiętaj, że umiejscowienie grafiki może się różnić w zależności od rozmiaru oraz kraju.',
    note2: 'Najpierw naszkicuj cały rysunek tak, aby zmieścił się na pudełku.',
    numberSpace: 'liczba = odstępy między kropkami',
    diagonal: 'przekątna',
    LEFT: 'LEWO (część)',
    RIGHT: 'PRAWO (część)',
    TOP: 'GÓRA (część)',
    TOP1: 'GÓRA (część) 1',
    TOP2: 'GÓRA (część) 2',
    BACK: 'TYŁ (część)',
    MIDDLE: 'ŚRODEK (część)',
    MIDDLE2: 'ŚRODEK (część) 2',
    BOTTOM: 'DÓŁ (część)',
    FRONT: 'PRZÓD (część)',
    SIDE: 'BOK (część)',
    secondSIDE: 'DRUGI BOK (część)',
    secondSIDE1: 'DRUGI BOK (część) 1',
    secondSIDE2: 'DRUGI BOK (część) 2',
    LEG: 'NOGA (część)', //update
    JOINT: 'ZŁĄCZE (część)', //update
    FACE: 'TWARZ (część)', //update
    DRAWERBOTTOM: 'DÓŁ SZUFLADY (część)', //update
    DRAWERSIDE: 'BOK SZUFLADY (część)', //update
    NOSE: 'NOS (część)', //update
    HANDLE: 'UCHWYT (część)', //update
    BOTTOMSIDE: 'DOLNY BOK (część)', //update
    TOPSIDE: 'GÓRNY BOK (część)', //update
    WING: 'SKRZYDŁO (część)', //update
    cutAndAssemble: "Czas na wycinanie i składanie.",
    beCareful: 'Uważaj, aby nie zranić się podczas korzystania z noża.',
    cutOutParts: 'Wytnij części.',
    assemble: 'Złóż.',
    Assemblyguide: 'Przewodnik po montażu', //update
    fold: 'Jak złożyć karton?',
    foldGuide: 'Wykorzystaj krawędź mebla do zaginania kartonu.',
    foldGuideDezeen:
      'Aby ułatwić zaginanie kartonu, naciśnij kilkukrotnie wykropkowaną linię za pomocą narzędzi do bigowania.', //update
    glue: 'Nałóż równomiernie klej lub taśmę.', //update
    cable: 'Do połączenia wykorzystaj sznurki lub opaski kablowe.', //update
    done: 'Gotowe!',
    goBack: 'Wróć do menu głównego',
  },
  CautionPage: {
    CAUTION: 'UWAGA',
    needItem: 'Będziesz potrzebował tych przedmiotów.',
    children: 'Dzieci powinny przebywać pod opieką dorosłych.',
    mat:
      'Zabezpiecz podłoże, aby zapobiec zadrapaniom podczas procesu.',
    doNotPutHeavyThing:
      'Nie wchodź ani nie siadaj na tych meblach i staraj się nie kłaść na nich ciężkich przedmiotów.',
    doNotThrow:
      'Nie kop i nie rzucaj meblami w żadnym kierunku, w szczególności ludzi i zwierząt.',
    stayAwayFlame: 'Trzymaj z dala od płomieni.',
    stayAwayWater: 'Trzymaj z dala od wody lub wilgoci.',
    mayDamaged: '* Pudełko od telewizora może ulec zniszczeniu podczas procesu dostawy.',
    companyDoestResponsible:
      '* Firma nie ponosi żadnej odpowiedzialności za awarie lub urazy poniesione podczas tej pracy.',
    cannotBeReturned:
      '* Produkt z uszkodzonym pudełkiem nie może zostać zwrócony z powodu problemów z jakością opakowania.',
    understand: 'Tak, rozumiem',
  },
  PrivacyPolicy: {
    title: 'Polityka prywatności',
  },
  GoingGreen: {
    visual: {
      title: 'Stawiamy na ekologię',
      text1:
        'W porównaniu do poprzednich opakowań, zużyliśmy mniej papieru i atramentu w większości pudełek do telewizorów, aby zwiększyć nasze zaangażowanie w zrównoważony rozwój.',
      text2:'',
      text2_special:
        '(* Nie dotyczy niektórych modeli, w tym telewizorów Lifestyle.)',
      text3: 'Wybierz przycisk poniżej, by dowiedzieć się więcej.',
    },
    greenIn: {
      title: 'Stawiamy na ekologię w opakowaniach telewizorów.',
      subtitle1: 'Wyszukaj informacji o produkcie.',
      subtitle2: 'Upcyklingowe Ekologiczne Opakowanie.',
      desc: 'Wyszukaj nazwę modelu, by dowiedzieć się więcej.',
      descM: '* Zrób zdjecie numeru modelu telewizora.',
      guide: 'nazwa modelu',
      button: 'Zrób zdjęcie',
      button2: 'Idź do tworzenia przedmiotów',
      product_info: 'Informacje o produkcie',
    },
    search: {
      guide: 'Szukaj..',
      noResult: 'Brak wyników',
      more: 'WIĘCEJ',
      search: 'Szukaj',
      retake: 'Jeszcze raz',
      result: 'Wyniki wyszukiwania',
    },
    photo: {
      guide1: 'Wpisz nazwę modelu telewizora podaną na pudełku',
      guide2: '(np. Q800A, AUT7000, RU7100 itp.)',
    },
  },
  searchCountrySelect: 'Wybierz kraj, aby wyszukać'
};
